import firebase  from "firebase"

class Order{
    constructor (name,phone,adId, done=false, id=null) {
        this.name = name
        this.phone = phone
        this.done = done
        this.adId = adId
        this.id = id
    }
}

export default {
    state:{
        orders:[]
    },
    mutations:{
        loadOrders (state, payload) {
            state.orders = payload
        }
    },
    actions:{
        async createOrder ({commit}, {name,phone,adId,ownerId}) {
            const order = new Order(name,phone,adId,ownerId)
            commit ('clearError')
            try {
                await firebase.database().ref(`/users/${ownerId}/orders`).push(order)
            } catch (error) {
                commit('setError', error.message)
                throw error
            }
        },
        async fetchOrders ({commit, getters}) {
            commit('setLoading', true)
            commit('clearError')
            const resultOrders = []
            try {
                const firebaseValue = await firebase.database().ref(`/users/${getters.user.id}/orders`).once('value')
                const orders = firebaseValue.val()
                Object.keys(orders).forEach(key => {
                    const order = orders[key]
                    resultOrders.push(
                        new Order(order.name, order.phone, order.adId, order.done, key)
                    )
                })
                commit('loadOrders', resultOrders)
                commit('setLoading', false)

            } catch (error) {
                commit('setLoading', false)
                commit('setError', error.message)
            }
        },
        async markOrderDone ({commit, getters}, payload) {
            commit('clearError')
            try {
                await firebase.database().ref(`/users/${getters.user.id}/orders`).child(payload).update({
                  done: true
                })
              } catch (error) {
                commit('setError', error.message)
                throw error
              }
        }
    },
    getters:{
        doneOrders (state) {
            return state.orders.filter(o => o.done)
        },
        undoneOrders (state) {
            return state.orders.filter(o => !o.done)

        },
        orders (state, getters) {
            return getters.undoneOrders.concat(getters.doneOrders)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/orders.js